
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("18ETW"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("18ETW", function(module, exports) {

let $0d4643f629a2506c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d4643f629a2506c$var$load("cRtGo"),
    $0d4643f629a2506c$var$load("hCiBy"),
    $0d4643f629a2506c$var$load("3q2Ng"),
    $0d4643f629a2506c$var$load("jRpDi"),
    $0d4643f629a2506c$var$load("iXxzp"),
    $0d4643f629a2506c$var$load("dYtBN"),
    $0d4643f629a2506c$var$load("kNV5Y"),
    $0d4643f629a2506c$var$load("jUBhK"),
    $0d4643f629a2506c$var$load("ddJJa"),
    $0d4643f629a2506c$var$load("27glK"),
    $0d4643f629a2506c$var$load("bvY53"),
    $0d4643f629a2506c$var$load("f6ci5"),
    $0d4643f629a2506c$var$load("7jSfd"),
    $0d4643f629a2506c$var$load("4HZlX"),
    $0d4643f629a2506c$var$load("kDqHr"),
    $0d4643f629a2506c$var$load("gT8XU"),
    $0d4643f629a2506c$var$load("3GuOt"),
    $0d4643f629a2506c$var$load("3Mspc"),
    $0d4643f629a2506c$var$load("9aQIt"),
    $0d4643f629a2506c$var$load("XZauT"),
    $0d4643f629a2506c$var$load("4S1SF"),
    $0d4643f629a2506c$var$load("lm9Lt"),
    $0d4643f629a2506c$var$load("9wPDc"),
    $0d4643f629a2506c$var$load("1MWOL"),
    $0d4643f629a2506c$var$load("6fQco"),
    $0d4643f629a2506c$var$load("aOY32"),
    $0d4643f629a2506c$var$load("3MYQs"),
    $0d4643f629a2506c$var$load("6SWFK"),
    $0d4643f629a2506c$var$load("5zapo"),
    $0d4643f629a2506c$var$load("jiFtb"),
    $0d4643f629a2506c$var$load("6wr18"),
    $0d4643f629a2506c$var$load("9atVd"),
    $0d4643f629a2506c$var$load("dek7I"),
    $0d4643f629a2506c$var$load("6iz6l"),
    $0d4643f629a2506c$var$load("4SCW2"),
    $0d4643f629a2506c$var$load("fdKpi"),
    $0d4643f629a2506c$var$load("ffEVr"),
    $0d4643f629a2506c$var$load("hhss7"),
    $0d4643f629a2506c$var$load("5JkDi"),
    $0d4643f629a2506c$var$load("eTYdV"),
    $0d4643f629a2506c$var$load("Wowvf"),
    $0d4643f629a2506c$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("4lSZX"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("4lSZX", function(module, exports) {

let $32b3c91f85d910a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $32b3c91f85d910a2$var$load("cRtGo"),
    $32b3c91f85d910a2$var$load("hCiBy"),
    $32b3c91f85d910a2$var$load("6wr18"),
    $32b3c91f85d910a2$var$load("3j4Bc"),
    $32b3c91f85d910a2$var$load("2tIxk"),
    $32b3c91f85d910a2$var$load("dLq4a"),
    $32b3c91f85d910a2$var$load("27glK"),
    $32b3c91f85d910a2$var$load("bvY53"),
    $32b3c91f85d910a2$var$load("ffEVr"),
    $32b3c91f85d910a2$var$load("219St"),
    $32b3c91f85d910a2$var$load("b1DMS"),
    $32b3c91f85d910a2$var$load("eTYdV"),
    $32b3c91f85d910a2$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("5iMzz"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("5iMzz", function(module, exports) {

let $3dc44fb73f8331c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3dc44fb73f8331c5$var$load("buoeZ"),
    $3dc44fb73f8331c5$var$load("h3ABO"),
    $3dc44fb73f8331c5$var$load("5o4Kn"),
    $3dc44fb73f8331c5$var$load("6rS39"),
    $3dc44fb73f8331c5$var$load("kbwlB"),
    $3dc44fb73f8331c5$var$load("2OkLl"),
    $3dc44fb73f8331c5$var$load("2YffH"),
    $3dc44fb73f8331c5$var$load("4FGsA"),
    $3dc44fb73f8331c5$var$load("jSPb6"),
    $3dc44fb73f8331c5$var$load("9XOeB"),
    $3dc44fb73f8331c5$var$load("xu7ej"),
    $3dc44fb73f8331c5$var$load("iQ4FP"),
    $3dc44fb73f8331c5$var$load("5wJc7"),
    $3dc44fb73f8331c5$var$load("k3Yy8"),
    $3dc44fb73f8331c5$var$load("jEvZI"),
    $3dc44fb73f8331c5$var$load("im1VN"),
    $3dc44fb73f8331c5$var$load("9yprC"),
    $3dc44fb73f8331c5$var$load("9anPW"),
    $3dc44fb73f8331c5$var$load("fjVVr"),
    $3dc44fb73f8331c5$var$load("rFdxz"),
    $3dc44fb73f8331c5$var$load("aapZc"),
    $3dc44fb73f8331c5$var$load("gnDXu"),
    $3dc44fb73f8331c5$var$load("5XC9j"),
    $3dc44fb73f8331c5$var$load("iqTGf"),
    $3dc44fb73f8331c5$var$load("3q2Ng"),
    $3dc44fb73f8331c5$var$load("jRpDi"),
    $3dc44fb73f8331c5$var$load("jUBhK"),
    $3dc44fb73f8331c5$var$load("ddJJa"),
    $3dc44fb73f8331c5$var$load("f6ci5"),
    $3dc44fb73f8331c5$var$load("lTK3c"),
    $3dc44fb73f8331c5$var$load("1WXdc"),
    $3dc44fb73f8331c5$var$load("e9sw5"),
    $3dc44fb73f8331c5$var$load("3ykLj"),
    $3dc44fb73f8331c5$var$load("b2FtX"),
    $3dc44fb73f8331c5$var$load("g6S1i"),
    $3dc44fb73f8331c5$var$load("hXxv0"),
    $3dc44fb73f8331c5$var$load("6iz6l"),
    $3dc44fb73f8331c5$var$load("4SCW2"),
    $3dc44fb73f8331c5$var$load("c0JsV"),
    $3dc44fb73f8331c5$var$load("1OKix"),
    $3dc44fb73f8331c5$var$load("lVrrs"),
    $3dc44fb73f8331c5$var$load("3NkiL"),
    $3dc44fb73f8331c5$var$load("cRtGo"),
    $3dc44fb73f8331c5$var$load("6wr18"),
    $3dc44fb73f8331c5$var$load("4YJm9"),
    $3dc44fb73f8331c5$var$load("jvHRs"),
    $3dc44fb73f8331c5$var$load("2tIxk"),
    $3dc44fb73f8331c5$var$load("dLq4a"),
    $3dc44fb73f8331c5$var$load("27glK"),
    $3dc44fb73f8331c5$var$load("bvY53"),
    $3dc44fb73f8331c5$var$load("5bjXP"),
    $3dc44fb73f8331c5$var$load("hhss7"),
    $3dc44fb73f8331c5$var$load("Wowvf"),
    $3dc44fb73f8331c5$var$load("ffEVr"),
    $3dc44fb73f8331c5$var$load("219St"),
    $3dc44fb73f8331c5$var$load("b1DMS"),
    $3dc44fb73f8331c5$var$load("jnVKv"),
    $3dc44fb73f8331c5$var$load("hCiBy"),
    $3dc44fb73f8331c5$var$load("7EorR"),
    $3dc44fb73f8331c5$var$load("bgHzk"),
    $3dc44fb73f8331c5$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.9cfd2702.js.map
